import {
  BEGIN_LOADING,
  CLEAR_LOADING,
  SEND_CODE,
  SIGNUP_MEMBER,
  LOGIN_MEMBER,
  GET_MEMBER,
  SEND_CODE_LOGIN,
  FORGET_PASSWORD,
  SEND_CODE_EMAIL,
  CHANGE_EMAIL,
  EMAIL_VERIFICATION,
  SEND_CODE_MOBILE,
  CHANGE_MOBILE,
  CHANGE_PASSWORD,
} from "../actions/types";

import { getLoggedInUser } from "../helpers/authUtils";

const initialState = {
  sendCodeResult: {},
  signUpResult: {},
  member: getLoggedInUser(),
  sendCodeLoginResult: {},
  forgetPasswordResult: {},
  member_data: {},
  sendCodeEmailResult: {},
  changeEmailResult: {},
  emailVerificationResult: {},
  sendCodeMobileResult: {},
  changeMobileResult: {},
  changePasswordResult: {},
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SEND_CODE:
      return {
        ...state,
        sendCodeResult: action.payload,
        loading: false
      };
    case SIGNUP_MEMBER:
      return {
        ...state,
        signUpResult: action.payload,
        loading: false
      };
    case LOGIN_MEMBER:
      return {
        ...state,
        member: action.payload,
        loading: false
      };
    case SEND_CODE_LOGIN:
      return {
        ...state,
        sendCodeLoginResult: action.payload,
        loading: false
      };
    case FORGET_PASSWORD:
      return {
        ...state,
        member: action.payload,
        loading: false
      };
    case GET_MEMBER:
      return {
        ...state,
        member_data: action.payload,
        loading: false
      };
    case SEND_CODE_EMAIL:
      return {
        ...state,
        sendCodeEmailResult: action.payload,
        loading: false
      };
    case CHANGE_EMAIL:
      return {
        ...state,
        changeEmailResult: action.payload,
        loading: false
      };
    case EMAIL_VERIFICATION:
      return {
        ...state,
        emailVerificationResult: action.payload,
        loading: false
      };
    case SEND_CODE_MOBILE:
      return {
        ...state,
        sendCodeMobileResult: action.payload,
        loading: false
      };
    case CHANGE_MOBILE:
      return {
        ...state,
        changeMobileResult: action.payload,
        loading: false
      };
    case CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordResult: action.payload,
        loading: false
      };
    case BEGIN_LOADING:
      return {
        ...state,
        loading: true
      };
    case CLEAR_LOADING:
      return {
        ...state,
        loading: false
      };

    default:
      return state;
  }
}
